@if (fileList.length > 0) {
<table mat-table [dataSource]="fileList" class="file-list-table full-width mat-elevation-z2">

  <!-- Icon Column -->
  <ng-container matColumnDef="icon">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let file" class="icon-cell">
      <mat-icon [style.color]="getFileIconColor(file.FileType, file.OriginalFileName || file.FileName)">
        {{ getFileIcon(file.FileType, file.OriginalFileName || file.FileName) }}
      </mat-icon>
    </td>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef>Name</th>
    <td mat-cell *matCellDef="let file">
      <span class="file-name-link" (click)="open(file)">
        {{ getDisplayName(file) }}
      </span>
    </td>
  </ng-container>

  <!-- Uploaded By Column -->
  <ng-container matColumnDef="uploadedBy">
    <th mat-header-cell *matHeaderCellDef>Uploaded By</th>
    <td mat-cell *matCellDef="let file">{{ file.CreatedBy?.Name || '—' }}</td>
  </ng-container>

  <!-- Uploaded On Column -->
  <ng-container matColumnDef="uploadedOn">
    <th mat-header-cell *matHeaderCellDef>Uploaded On</th>
    <td mat-cell *matCellDef="let file">{{ file.CreatedOn | date:'MM/dd/yyyy' }}</td>
  </ng-container>

  <!-- Size Column -->
  <ng-container matColumnDef="size">
    <th mat-header-cell *matHeaderCellDef>Size</th>
    <td mat-cell *matCellDef="let file">{{ formatSize(file.FileSize) }}</td>
  </ng-container>

  <!-- Actions Column -->
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef style="text-align: right;"></th>
    <td mat-cell *matCellDef="let file" style="text-align: right; white-space: nowrap;">
      <button mat-icon-button matTooltip="Open in new tab" (click)="openInTab(file)">
        <mat-icon>open_in_new</mat-icon>
      </button>
      <button mat-icon-button matTooltip="Download" (click)="download(file)">
        <mat-icon>cloud_download</mat-icon>
      </button>
      @if (canDelete) {
      <button mat-icon-button matTooltip="Delete" color="warn" (click)="remove(file)">
        <mat-icon>delete</mat-icon>
      </button>
      }
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="file-row"></tr>
</table>
}
